@for (toast of content(); track toast.id) {
  <div [@fadeIn]="fadeIn()">
    <ng-container
      [ngComponentOutlet]="toast.config.component"
      [ngComponentOutletInputs]="{ toast: toast }"></ng-container>
  </div>
}
